<nz-alert
  class="mb-4"
  nzType="warning"
  [nzMessage]="(temporary ? 'expiredPsd.tempAlertTitle' : 'expiredPsd.alertTitle') | translate"
  [nzDescription]="(temporary ? 'expiredPsd.tempAlertDesc' : 'expiredPsd.alertDesc') | translate"
  nzShowIcon
></nz-alert>

<form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="handleOk()">
  <app-psd-fields [form]="form"/>
</form>
